var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/heart-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6804 14.1096V14.0996C19.8004 13.1696 18.5704 12.5996 17.2004 12.5996C14.5504 12.5996 12.4004 14.7496 12.4004 17.3996C12.4004 18.6296 12.8704 19.7496 13.6304 20.5996C14.5104 21.5796 15.7804 22.1996 17.2004 22.1996C19.8504 22.1996 22.0004 20.0496 22.0004 17.3996C22.0004 16.1296 21.5004 14.9696 20.6804 14.1096ZM18.9904 18.2096H17.9504V19.2996C17.9504 19.7096 17.6104 20.0496 17.2004 20.0496C16.7904 20.0496 16.4504 19.7096 16.4504 19.2996V18.2096H15.4104C14.9904 18.2096 14.6604 17.8796 14.6604 17.4596C14.6604 17.0496 14.9804 16.7196 15.4004 16.7096H16.4504V15.7096C16.4504 15.6896 16.4504 15.6696 16.4604 15.6496C16.4804 15.2696 16.8104 14.9596 17.2004 14.9596C17.6004 14.9596 17.9304 15.2796 17.9504 15.6796V16.7096H18.9904C19.4104 16.7096 19.7404 17.0496 19.7404 17.4596C19.7404 17.8796 19.4104 18.2096 18.9904 18.2096Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 8.92984C22 10.1198 21.81 11.2198 21.48 12.2398C21.42 12.4498 21.17 12.5098 20.99 12.3798C19.9 11.5698 18.57 11.1398 17.2 11.1398C13.73 11.1398 10.9 13.9698 10.9 17.4398C10.9 18.5198 11.18 19.5798 11.71 20.5198C11.87 20.7998 11.68 21.1598 11.38 21.0498C8.97 20.2298 4.1 17.2398 2.52 12.2398C2.19 11.2198 2 10.1198 2 8.92984C2 5.83984 4.49 3.33984 7.56 3.33984C9.37 3.33984 10.99 4.21984 12 5.56984C13.01 4.21984 14.63 3.33984 16.44 3.33984C19.51 3.33984 22 5.83984 22 8.92984Z",
    fill: "#6C84F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartAdd);
export default __webpack_public_path__ + "static/media/heart-add.bd14b26357d9105745cc5b533285ee0b.svg";
export { ForwardRef as ReactComponent };